/**
 * @module Achievement Feature
 *
 * @import {ctxVipPoints} from "../context/points";
 */

import {GlobalWatch} from '@acng/frontend-relativity';
import {guard} from '@acng/frontend-rubicon';
import {HIDDEN} from '@acng/frontend-bounty/dom/attribute.js';
import {remove} from '@acng/frontend-bounty/dom/move.js';

import {createFrontendFeature} from '../../core/model/feature.js';
import {hasFeature} from '../../core/service/env.js';
import {listen} from '../../core/context/event-bus.js';
import {ctxAuthUser} from '../../userPool/context/auth-user.js';
import {EVENTBUS_USER} from '../../user/model/user-data.js';
import {VipPointsProvider} from '../context/points.js';

let initialized = false;

const name = 'achievement';

export const feature = createFrontendFeature(name);

feature[HIDDEN] = !hasFeature(name);

/**
 * Start with the continuous provision of the current
 * {@link ctxVipPoints | "VIP points"} or just remove the element if the
 * achievement feature is hidden.
 *
 * @type {(element: Element) => void}
 */
export const compile = (() => {
  const provide = VipPointsProvider();

  return (element) => {
    if (feature[HIDDEN]) {
      remove(element);
    } else if (!initialized) {
      GlobalWatch(ctxAuthUser)((user) => provide(user?.points ?? NaN));

      listen('user', (data) => {
        ASSERT: guard(data, EVENTBUS_USER);
        //DEBUG: if (VERBOSE) console.info(`${MODULE}`, data);

        provide(data.user.points);
      });

      /*
      TEST_DATA: {
        let fakePoints = 0;
        (function fake() {
          fakePoints += Math.round(Math.random() * 50) + 1;
          provide(fakePoints);
          setTimeout(
            () => {
              fake();
            },
            Math.random() * 2500 + 500,
          );
        })();
      }
      */

      initialized = true;
    }
  };
})();
